import React, { useContext, useEffect, useState } from 'react';
import Algolia from '../../../search/services/Algolia';
import Select from './Select';
import { DEFAULT_VALUE, FACETS, LABELS, PARAM_NAME } from '../../config/facets';
import { useDispatch, useSelector } from 'react-redux';
import { resetFilters, setFacetValue } from '../../actions/searchAction';
import Translation, { TranslationContext } from '../../../common/Translation';
import Url from '../../helpers/UrlHelper';
import ResetFiltersButton from '../../../search/components/ResetFiltersButton';

const Form = ({ hasBtn = false }) => {
  const [facets, setFacets] = useState({});
  const search = useSelector(state => state.search)
  const dispatch = useDispatch();
  const { translationRegistry: translations } = useContext(TranslationContext)

  useEffect(() => {
    Object.values(FACETS).forEach(async (facet) => {
      const results = await Algolia.getFacets(facet);
      setFacets(prevState => ({
        ...prevState,
        [facet]: results
      }))
    })
  }, []);

  const handleOnChange = (facetType, value) => {
    dispatch(setFacetValue(facetType, value));

    if (!hasBtn) {
      Url.setParam(PARAM_NAME[facetType], value);
      Url.deleteParam('page');
    }
  }

  return (
    <form
      action={translations.search_url}
      className="crtSearchInspiration-form"
      role="search"
      method="GET"
    >
      {
        Object.values(FACETS).map(facetName => (
          facets[facetName] && (
            <Select
              id={facetName}
              name={PARAM_NAME[facetName]}
              key={facetName}
              label={LABELS[facetName]}
              value={search.facets[facetName]}
              defaultValue={DEFAULT_VALUE[facetName]}
              options={facets[facetName].map(facet => ({
                label: facet.value,
                value: facet.value
              }))}
              onChange={handleOnChange}
            />
          )
        ))
      }

      {
        hasBtn
          ? (
            <div className="crtSearchInspirationSubmit">
              <button
                tabIndex={0}
                type="submit"
                role="button"
                className="crtSearchInspirationSubmitButton"
              >
                <svg viewBox="0 0 100 100" className="crt-icon-search">
                  <use xlinkHref="#crt-search"></use>
                </svg>
                <span className="crtSearchInspirationSubmitLabel"><Translation id="btn_discover" /></span>
              </button>
            </div>
          )
          : <ResetFiltersButton action={() => dispatch(resetFilters())} />
      }
    </form>
  );
};

export default Form;
